module.exports = __webpack_public_path__ + "assets/fonts/equilibrio.svg";